import { formatCurrency, formatPercent, formatNumber } from './formatters'
import type { CalculatorResult } from '../types'

export interface PlanejamentoInputs {
  faturamento: number
  precoProduto: number
  taxaLeadAgendamento: number
  taxaAgendadaRealizada: number
  taxaConsultaVenda: number
  precoLead: number
}

export function calcularPlanejamento(inputs: PlanejamentoInputs): CalculatorResult[] {
  const { faturamento, precoProduto, taxaLeadAgendamento, taxaAgendadaRealizada, taxaConsultaVenda, precoLead } = inputs

  const vendas = precoProduto > 0 ? Math.ceil(faturamento / precoProduto) : 0

  const taxaAgendamentoDecimal = taxaLeadAgendamento / 100
  const taxaRealizadaDecimal = taxaAgendadaRealizada / 100
  const taxaVendaDecimal = taxaConsultaVenda / 100

  const taxaConversaoTotal = taxaAgendamentoDecimal * taxaRealizadaDecimal * taxaVendaDecimal
  const conversaoPercent = taxaConversaoTotal * 100

  const consultasRealizadas = taxaVendaDecimal > 0 ? Math.ceil(vendas / taxaVendaDecimal) : 0
  const agendamentos = taxaRealizadaDecimal > 0 ? Math.ceil(consultasRealizadas / taxaRealizadaDecimal) : 0
  const leads = taxaAgendamentoDecimal > 0 ? Math.ceil(agendamentos / taxaAgendamentoDecimal) : 0

  const investimento = leads * precoLead
  const lucro = vendas * precoProduto - investimento

  return [
    { label: 'Vendas Necessárias', value: vendas, formattedValue: formatNumber(vendas) },
    { label: 'Leads Necessários', value: leads, formattedValue: formatNumber(leads) },
    { label: 'Agendamentos', value: agendamentos, formattedValue: formatNumber(agendamentos) },
    { label: 'Consultas Realizadas', value: consultasRealizadas, formattedValue: formatNumber(consultasRealizadas) },
    { label: 'Taxa Lead → Venda', value: conversaoPercent, formattedValue: formatPercent(conversaoPercent) },
    { label: 'Investimento Necessário', value: investimento, formattedValue: formatCurrency(investimento) },
    { label: 'Lucro Estimado', value: lucro, formattedValue: formatCurrency(lucro), status: lucro > 0 ? 'success' : 'danger' },
  ]
}
